export const mapLoaded = (idName = "map") => {
  if (
    typeof google !== "undefined" &&
    google !== null &&
    google.maps != null &&
    document.getElementById(idName) != null
  )
    return true;
  return false;
};

export default mapLoaded;

export const mapLoadedChina = (idName = "map") => {
  if (
    typeof mapboxgl !== "undefined" &&
    mapboxgl !== null &&
    mapboxgl.maps != null &&
    mapboxgl.supported() &&
    document.getElementById(idName) != null
  )
    return true;
  return false;
};
